export function base64ToBlob(base64, mimeType) {
    // Decodifica la base64 a una cadena de bytes
    const byteString = atob(base64)

    // Crea un array de bytes a partir de la cadena
    const byteArray = new Uint8Array(byteString.length)
    for (let i = 0; i < byteString.length; i++) {
        byteArray[i] = byteString.charCodeAt(i)
    }

    // Crea el Blob con el tipo MIME que quieras
    return new Blob([byteArray], { type: mimeType })
}
